/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for gbcar-api services
 */
@Injectable({
  providedIn: 'root',
})
export class GbcarApiConfiguration {
  rootUrl: string = '';
}

export interface GbcarApiConfigurationInterface {
  rootUrl?: string;
}
